/**
 * v3 — quick add on a collection card. 21 September 2026.
 *
 * THE FIRST fetch('/cart/add.js') IN THE BUILD. Everything else in v3 adds to
 * the bag by native form POST: sections/v3-product-buybox.liquid is a real
 * {% form 'product' %} and assets/v3-buybox.js intercepts nothing. That was a
 * deliberate simplicity and it is worth saying why it ends here — a grid of
 * twenty-four cards cannot navigate away and come back for each add without
 * losing the shopper's place in the grid, which is the whole point of adding
 * from the grid.
 *
 * D11 HOLDS. Nothing can be added until a size is pressed. The Add button
 * starts disabled, is armed only by an available variant, and is disarmed
 * again by a sold-out one. The live theme's equivalent presets
 * selected_or_first_available_variant and posts it on click — on the first
 * Arbi card that is UK 4/37, so a shopper who never opens the size list buys
 * a 4 without being told. That is the defect this file exists not to have.
 *
 * NO INVENTED COPY. Every string comes from a data- attribute the Liquid
 * filled from the locale. The one path with no approved string is a FAILED
 * add, and it stays silent on purpose: aria-invalid and a marker, no sentence.
 * assets/v3-cart.js took the same decision for a failed note save, and the
 * missing slot is reported to Sumit rather than filled here.
 */
(function () {
  'use strict';

  var OPEN = '[data-v3-qa-open]';
  var SHEET = '[data-v3-qa-sheet]';
  var busy = false;

  function sheetOf(root) { return root ? root.querySelector(SHEET) : null; }
  function openerOf(root) { return root ? root.querySelector(OPEN) : null; }

  /** One sheet at a time. Two open sheets in a grid overlap the cards beneath
   *  them and there is no reading order that makes sense of both. */
  function closeAll(except) {
    var roots = document.querySelectorAll('[data-v3-qa]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i] === except) continue;
      close(roots[i], false);
    }
  }

  function open(root) {
    closeAll(root);
    var sheet = sheetOf(root), opener = openerOf(root);
    if (!sheet || !opener) return;
    sheet.hidden = false;
    opener.setAttribute('aria-expanded', 'true');
    root.setAttribute('data-open', '');
    // Into the sizes, which is what she opened it for. The sheet's contents
    // are not focusable while it is hidden, so this is also the moment they
    // enter the tab order at all.
    var first = sheet.querySelector('[data-v3-qa-size]');
    if (first) first.focus();
  }

  function close(root, restoreFocus) {
    var sheet = sheetOf(root), opener = openerOf(root);
    if (!sheet || !opener) return;
    if (sheet.hidden) return;
    sheet.hidden = true;
    sayFail(root, '');             // Q08: a closed sheet keeps no stale sentence
    opener.setAttribute('aria-expanded', 'false');
    root.removeAttribute('data-open');
    if (restoreFocus && opener.focus) opener.focus();
  }

  // `quiet` is the Q08 path: the sentence it writes is the announcement, and a
  // "Sold out" through the status first would say it twice.
  function pick(root, chip, quiet) {
    var sheet = sheetOf(root);
    if (!sheet) return;
    var chips = sheet.querySelectorAll('[data-v3-qa-size]');
    for (var i = 0; i < chips.length; i++) {
      chips[i].setAttribute('aria-pressed', chips[i] === chip ? 'true' : 'false');
    }
    var add = sheet.querySelector('[data-v3-qa-add]');
    var status = sheet.querySelector('[data-v3-qa-status]');
    if (!add) return;

    var soldOut = chip.hasAttribute('data-v3-soldout');
    add.removeAttribute('aria-invalid');

    if (soldOut) {
      // Selected, and still not purchasable. The chip is a real control — it
      // says which size she asked for — but the shoe in it does not exist, so
      // the button cannot arm. Same state the PDP reaches by the same route.
      add.disabled = true;
      add.setAttribute('aria-disabled', 'true');
      add.textContent = add.getAttribute('data-label-sold-out') || add.textContent;
      add.removeAttribute('data-v3-variant');
      add.removeAttribute('data-v3-po');
      // A label change on a disabled button is not reliably announced, so the
      // live region carries it. Approved string, from the same attribute.
      if (status && !quiet) status.textContent = add.getAttribute('data-label-sold-out') || '';
      return;
    }

    add.disabled = false;
    add.removeAttribute('aria-disabled');
    // A pre-order size (W-20261019-2) says so on the button and carries its
    // line property, exactly as on the product page.
    var po = chip.getAttribute('data-v3-po-prop') || '';
    add.textContent = (po ? add.getAttribute('data-label-preorder') : add.getAttribute('data-label-add')) || add.textContent;
    add.setAttribute('data-v3-variant', chip.getAttribute('data-v3-variant') || '');
    if (po) add.setAttribute('data-v3-po', po); else add.removeAttribute('data-v3-po');
    if (status) status.textContent = '';
  }

  /* ── Q08: A REFUSED ADD FOR A SIZE THAT HAS GONE — 27 September ──────────
     Every failure used to land in one silent .catch. One now has words: a 422
     whose description says the size is sold out — the same test the product
     page's buy box applies (assets/v3-buybox.js), so the two surfaces agree
     on what counts. That marks the chip sold out the way the Liquid marks
     one, disarms Add through pick(), and says Sumit's no-email sentence once.
     Anything else — another 422 (the last pair already in her bag), a 5xx, a
     dropped connection — is exactly as before: aria-invalid, the button
     back, no sentence, no navigation (decision 4). The success path is
     unchanged. Design adapted from the CRO session's tested 26 Sep patch. */
  function failOf(root) { return root ? root.querySelector('[data-v3-qa-fail]') : null; }
  function sayFail(root, text) { var f = failOf(root); if (f) f.textContent = text || ''; }

  function soldOutNow(root, add, id) {
    var sheet = sheetOf(root), fail = failOf(root);
    var chip = sheet ? sheet.querySelector('[data-v3-qa-size][data-v3-variant="' + id + '"]') : null;
    if (!chip || !fail) throw new Error('422');
    if (!chip.hasAttribute('data-v3-soldout')) {
      chip.setAttribute('data-v3-soldout', '');
      var label = fail.getAttribute('data-chip-sold-out') || '';
      if (label) {
        var sr = document.createElement('span');
        sr.className = 'v3-sr';
        sr.textContent = ', ' + label;
        chip.appendChild(sr);
      }
    }
    // She pressed another size while the add was out: her newer choice
    // stands, and nothing is said about the old one.
    if (add.getAttribute('data-v3-variant') !== String(id)) return;
    pick(root, chip, true);
    if (sheet.hidden) return;      // closed meanwhile: nowhere to say it
    var uk = chip.getAttribute('data-v3-uk') || '';
    var withSize = fail.getAttribute('data-with-size') || '';
    sayFail(root, uk && withSize.indexOf('__SIZE__') > -1
      ? withSize.replace('__SIZE__', uk)
      : (fail.getAttribute('data-no-size') || ''));
  }

  // The line posted: a pre-order size carries its property (W-20261019-2).
  function line(add, id) {
    var item = { id: Number(id), quantity: 1 };
    var po = add.getAttribute('data-v3-po');
    var key = add.getAttribute('data-v3-po-key');
    if (po && key) { item.properties = {}; item.properties[key] = po; }
    return item;
  }

  function submit(root, add) {
    var id = add.getAttribute('data-v3-variant');
    if (!id || busy) return;
    busy = true;
    add.setAttribute('data-busy', '');
    add.disabled = true;
    sayFail(root, '');

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [line(add, id)] })
    })
      .then(function (r) {
        if (r.status === 422) {
          return r.json().then(null, function () { return {}; }).then(function (b) {
            var why = String((b && (b.description || b.message)) || '');
            if (!/sold out/i.test(why)) throw new Error('422');
            soldOutNow(root, add, id);
            return { refused: true };
          });
        }
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (res) {
        if (res && res.refused) return;
        close(root, false);
        // The drawer opening IS the confirmation, and a dialog taking focus is
        // announced without anything here having to say so. refresh() first so
        // what opens is the bag as it now stands rather than as it was.
        if (window.BTCart) {
          var done = window.BTCart.refresh();
          if (done && done.then) { done.then(function () { window.BTCart.open(); }); }
          else { window.BTCart.open(); }
        }
      })
      .catch(function () {
        // 422 (sold out between render and press), a dropped connection, a
        // 5xx — all land here. There is no approved string for it, so nothing
        // is said. The button comes back so she can try again, and the marker
        // is there for anyone reading the DOM.
        add.setAttribute('aria-invalid', 'true');
      })
      .then(function () {
        busy = false;
        add.removeAttribute('data-busy');
        if (add.getAttribute('data-v3-variant')) add.disabled = false;
        // Add was disabled while the request was out, so the browser dropped
        // focus to <body>. For a keyboard user the next Tab left the card,
        // which closes the sheet and wiped the sold-out sentence one keystroke
        // after it appeared. Found in review, 27 September. So focus comes back
        // into the sheet: to Add if it can fire again, otherwise to the size
        // she chose, in the group the sentence tells her to use. Only when
        // focus was actually lost — never taken from somewhere she moved it.
        var sheet = sheetOf(root), ae = document.activeElement;
        if (sheet && !sheet.hidden && (!ae || ae === document.body)) {
          var back = !add.disabled ? add
            : sheet.querySelector('[data-v3-qa-size][aria-pressed="true"]');
          if (back) back.focus();
        }
      });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest(OPEN);
    if (opener) {
      e.preventDefault();
      var root = opener.closest('[data-v3-qa]');
      var sheet = sheetOf(root);
      if (sheet && sheet.hidden) open(root); else close(root, true);
      return;
    }

    var chip = e.target.closest('[data-v3-qa-size]');
    if (chip) {
      e.preventDefault();
      var chipRoot = chip.closest('[data-v3-qa]');
      sayFail(chipRoot, '');       // Q08: a new choice retires the old sentence
      pick(chipRoot, chip);
      return;
    }

    var add = e.target.closest('[data-v3-qa-add]');
    if (add) { e.preventDefault(); submit(add.closest('[data-v3-qa]'), add); return; }

    // Anywhere else closes. Without this the sheet sits open over the cards
    // below it while she reads them.
    if (!e.target.closest('[data-v3-qa]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openRoot = document.querySelector('[data-v3-qa][data-open]');
    if (openRoot) close(openRoot, true);
  });

  /** Focus leaving the card closes its sheet. A sheet left open behind a
   *  keyboard user is the same overlap problem as two open at once, reached a
   *  different way. */
  document.addEventListener('focusin', function (e) {
    var openRoot = document.querySelector('[data-v3-qa][data-open]');
    if (openRoot && !openRoot.contains(e.target)) close(openRoot, false);
  });
}());
